import _slicedToArray from "/buddy/kaporg-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useToken } from '../../theme/internal';
/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */

var useCSSVarCls = function useCSSVarCls(prefixCls) {
  var _useToken = useToken(),
      _useToken2 = _slicedToArray(_useToken, 5),
      cssVar = _useToken2[4];

  return cssVar ? "".concat(prefixCls, "-css-var") : '';
};

export default useCSSVarCls;